import { getToken } from './auth';

const config = window.pcaSettings;

export async function listCognitoUsers(
  groupName,
  search,
  paginationToken
) {
  const token = await getToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  let url;
  if (groupName) {
    url = `${config.api.uri}/auth/group/${encodeURIComponent(groupName)}`;
  } else {
    url = `${config.api.uri}/auth`;
  }

  const params = new URLSearchParams();
  if (search) params.append('search', search);
  if (paginationToken) params.append('paginationToken', paginationToken);
  if ([...params].length) {
    url += `?${params.toString()}`;
  }

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }

  return response.json();
}

export async function listAssignableUsers() {
  const token = await getToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  const url = `${config.api.uri}/auth/assignable-users`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch assignable users');
  }

  return response.json();
}

export async function listCognitoGroups() {
  const token = await getToken();
  if (!token) {
    throw new Error('Not authenticated');
  }

  const url = `${config.api.uri}/groups`;

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch groups');
  }

  const data = await response.json();
  return Array.isArray(data) ? { Groups: data } : data;
}
